import React from 'react';
import { Phone } from 'lucide-react';
export function MobileCtaBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden bg-nav border-t-2 border-accent shadow-2xl" data-id="element-292">
      <div className="grid grid-cols-2 divide-x divide-gray-700" data-id="element-293">
        <a href="tel:8472128045" className="flex items-center justify-center gap-2 py-4 text-white font-bold font-heading text-sm uppercase tracking-wide hover:bg-nav-hover active:bg-gray-800 transition-colors" aria-label="Call Dragon Martial Arts at (847) 212-8045" data-id="element-294">
          <Phone className="w-4 h-4 flex-shrink-0" aria-hidden="true" data-id="element-295" />
          <span data-id="element-296">Call Us</span>
        </a>
        <a href="#signup" className="flex items-center justify-center gap-2 py-4 bg-accent text-white font-bold font-heading text-sm uppercase tracking-wide hover:bg-red-700 active:bg-red-800 transition-colors" aria-label="Get One Week Free Trial" data-id="element-297">
          <span data-id="element-298">Free Trial</span>
        </a>
      </div>
    </div>;
}